import styled from 'styled-components';

export const AuditDefenseStyles = styled.div`
  background-color: #F5F5F7;
  .audit-defense-header {
    height: auto;

    ${props => props.theme.media.xl} {
      margin-top: 50px;
    }

    .container {
      ${props => props.theme.media.xl} {
        margin-top: 40px;
      }
    }

    h1 {
      color: #3F5261;
      font-size: 40px;
      font-weight: 500;

      ${props => props.theme.media.xl} {
        font-size: 50px;
        margin-bottom: 30px;
      }
    }

    .sub-header {
      max-width: 320px;
      width: 100%;
      margin: auto;

      ${props => props.theme.media.xl} {
        max-width: 522px;
      }
      
      p {
        font-family: Poppins;
        font-size: 20px;
        color: #3F5261;
        margin: auto; 
        line-height: 26px;
        font-weight: 350;

        ${props => props.theme.media.xl} {

        }
      }
    }

    .btn {
      height: 70px;
      max-width: 360px;
      width: 100%;
      font-size: 30px;
      margin-top: 38px;
      font-weight: 350;
      background-color: #FF6712;

      ${props => props.theme.media.xl} {
        height: 63px;
        max-width: 436px;
      }
    }
  }

  section.about-services {
    ${props => props.theme.media.xl} {
      margin-bottom: -50px; 
    }
  }

  section.learn-more-blogs {
    margin-top: -80px;
    ${props => props.theme.media.xl} {
      margin-top: -200px;
    }
    h2 {
      font-size: 30px;
      font-weight: 400;
      color: #505050;
      line-height: 30px;
      ${props => props.theme.media.xl} {
        font-size: 40px;
        margin-bottom: 20px;

      }
    }
    .section-subtitle {
      display: block;
      font-family: Poppins;
      font-size: 18px;
      line-height: 22px;
      font-weight: 350;
      width: 100%;
      max-width: 352px;
      margin: auto;
      margin-bottom: 20px;
      letter-spacing: 0px;
      ${props => props.theme.media.xl} {
        max-width: 670px;
        margin-bottom: 60px;
      }
    }

    .product-img {
      width: 100%;
      ${props => props.theme.media.xl} {
        max-width: 309px;
        margin: auto;
      }
    }

    .copy {
      .product-title {
        text-align: center !important;
        color: #3F5261 !important;
        ${props => props.theme.media.xl} {
  
        }
      }

      .text-center {
        color: #F15F22 !important;
        ${props => props.theme.media.xl} {
          text-align: center !important;
        } 
      }

      .text-center::after {
        display: none;
      }

      .product-description {
        font-weight: 350;
        line-height: 21px !important;
      }
    }

    .product:nth-child(2) {
      ${props => props.theme.media.xl} {
        .copy {
          .product-title {
            width: 100%;
            margin: auto;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
          }
        }
      }
    }

    .product:nth-child(3) {
      ${props => props.theme.media.xl} {
        .copy {
          .product-title {
            width: 100%;
            margin: auto;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
          }
        }
      }
    }
  }

  .irs-communication {
    display: block;
    padding: 30px 20px;
    margin-top: -40px;
    ${props => props.theme.media.lg} {
      margin-top: 0px;
      padding-bottom: 150px;
    }

    .container {
      padding: 20px;
      background: #E1EFEE;
      text-align: center;
      ${props => props.theme.media.lg} { 
        text-align: left;
        .inner {
          margin: auto;
          max-width: 740px;
          display: flex;
          padding: 20px 25px;
        }
      }

      img {
        width: 60px;
        ${props => props.theme.media.lg} {
          width: 90px;
          margin-right: 50px;
        }
      }

      h3 {
        color: #3F5261;
        font-size: 28px;    
        line-height: 28px;
        font-weight: 400;
        margin: 20px 0;
        span {
          display: none;
        }
        ${props => props.theme.media.lg} {
          font-size: 40px;
          font-weight: 500;
          span {
            display: inline;
          }
          br {
            display: none;
          }
        }
      }

      p {
        color: #3F5261;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  section.faq {
    padding-top: 0px;

    .container {
      h3 {
        max-width: 100%;
      }
    }
    .row {
      background: #F5F5F7;

      .Collapsible__trigger {
        text-align: left;
        text-transform: initial;
      }

      .Collapsible__contentInner {
        p {
          text-align: left;
        }
      }
    }
  }
`;
